export default [
  {
    path: '/caixa',
    name: 'Caixa Mensagem',
    component: () => import(/* webpackChunkName: "elaboracao-manter" */ './Lista.vue')
  }, {
    path: '/caixa/create',
    name: 'Criar Mensagem',
    component: () => import(/* webpackChunkName: "elaboracao-manter" */ './Mensagem.vue')
  }, {
    path: '/caixa/:identificador/edit',
    name: 'Editar Mensagem',
    component: () => import(/* webpackChunkName: "elaboracao-manter" */ './Mensagem.vue')
  }
]
